import React, {useState, useEffect} from 'react';





function MenuOptions ({infobreak, status, currStakedRacers}) {

    
    const [regStatus, setRegStatus] = useState("Closed");
 
    const [totwInfo, setTotwInfo] = useState({});
	const [weatherInfo, setWeatherInfo] = useState([]);
	const [advTrait, setAdvTrait] = useState("");
    const [buffInfo, setBuffInfo] = useState([]);
    const [leagueBreak, setLeagueBreak] = useState([]);

    useEffect(() => {
    const loadInit = async () => {
    let wandt = infobreak;
    setTotwInfo(wandt.totw);
    setWeatherInfo(wandt.weatherarray);
    setAdvTrait(wandt.advantage);
    setBuffInfo(wandt.buffs);
    
            if (!status){
                setRegStatus("Open");
            }else{
                setRegStatus("Closed");
            }   
        }
        loadInit();
        let tempcount = [0,0,0,0];
        for (let x = 0; x < currStakedRacers.length; x++){
            tempcount[currStakedRacers[x].league]++;
        }
        setLeagueBreak(tempcount);
    }, [infobreak, status, currStakedRacers]);

    return <nav className="navbar navbar-expand-sm" id="mainMenu">
        <div className="container-fluid">

            <div className="navbar-collapse collapse show" style={{width:'100%'}}>
                <div className="navbar-nav me-auto mb-2 mb-sm-0" style={{marginLeft: '60px', width:'20%', paddingRight:'40px'}}>
                    Registration: <span style={{color:(regStatus === 'Open' ? '#39ff14' : 'red'), paddingLeft:'10px'}}>{regStatus}</span>
                </div>
                <div className="navbar-nav me-auto mb-2 mb-sm-0" style={{margin: '0px auto 0px auto', width:'80%'}}>
                <div className="text-left" style={{padding:'0px'}} id="scroll-container"><div className="scrolling-text-inner"  role="marquee"><div id="scroll-text"><div className="scrolling-text-item">Total Racers Registered: {currStakedRacers.length}  (Rookie: {leagueBreak[3]} Elite: {leagueBreak[1]})</div><div className="scrolling-text-item">Trait of the Week: {(totwInfo === undefined ? "" : totwInfo.value + " (" + totwInfo.numberof + ")")} </div> {(weatherInfo === undefined ? "" : weatherInfo.map((weather,i) => (<div className="scrolling-text-item" key={i}>Weather Buffs: {weather.value} {weather.bonus} ({weather.numberof})</div>)))} {(buffInfo === undefined ? "" : buffInfo.map((weather,i) => (<div className="scrolling-text-item" key={i}>Seasonal Buffs: {weather.value} {weather.bonus} ({weather.numberof})</div>)))}<div className="scrolling-text-item">Advantage: {advTrait} </div></div></div></div>
                </div>
            </div>
        </div>
    </nav>

}

export {MenuOptions};